export default {
  SET_CATEGORY_DATA: (state, { value }) => {
    console.log("SET_DOWNLOAD_REPORT====", value);
    state.category_list = value;
    // state.category_list = [...state.category_list, ...value];
  },
};
